import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'AREA_UPDATE',
    smsDelete : 'AREA_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        area: [],

        submitSuccess: false,
        areaLoading: false,
        areaError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_AREA(state, area) {
            state.area = area;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        AREA_LOADING (state, loading) {
            state.areaLoading = loading;
        },

        AREA_ERROR (state, hasError) {
            state.areaError = hasError;
        }
    },

    actions: {
        async addArea ({commit, dispatch}, payload) {
            commit('AREA_LOADING', true);
            commit('AREA_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_area, payload.area, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchArea')
                return response

            } catch (e) {
                commit('AREA_ERROR', true);
            } finally {
                commit('AREA_LOADING', false);
            }
        },

        async fetchArea ({ commit }) {
            commit('AREA_LOADING', true);
            commit('AREA_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.area_list, config);
                let response = result.data
                commit('SET_AREA', response.data);

            } catch(error) {
                commit('AREA_ERROR', true);
            } finally {
                commit('AREA_LOADING', false);
            }
        },

        async fetchAreaByDistrict ({ commit }, payload) {
            commit('AREA_LOADING', true);
            commit('AREA_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.area_list_by_district + payload, config);
                let response = result.data
                commit('SET_AREA', response.data);

            } catch(error) {
                commit('AREA_ERROR', true);
            } finally {
                commit('AREA_LOADING', false);
            }
        },

        async updateArea ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.post(V1API.update_area + payload.id, payload.area, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchArea')
                return response

            } catch (e) {
                commit('AREA_ERROR', true);
            } finally {
                commit('AREA_LOADING', false);
            }
        },
        
        async deleteArea({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.area_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchArea')
            return response
        }
    },

    getters: {}
}
